<template>
  <div class="main-page-wrapper p0 font-halcom overflow-hidden">
    <div class="main-page-content">
      <transition name="fade">
        <SplashScreen v-if="showSplash" @splash-complete="showSplash = false" />
      </transition>
      <div v-show="!showSplash">
        <HeaderTwo/>
        <HeroBanner :content="content.hero" :reel="content.heroCarousel"/>
        <HomeSolutions/>
        <LogoCarousel/>
        <StepsCarousel />
        <GalleryVideo/>
        <ClientFeedback/>
        <faq-accordion />
        <FooterSeven :dark_bg="true" :dark_btn="true" />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTwo from '@/components/common/Headers/HeaderTwo.vue';
import HeroBanner from '@/components/content/hero-banner.vue';
import LogoCarousel from '@/components/content/logo-carousel.vue';
import StepsCarousel from '@/components/content/steps-carousel.vue';
import HomeSolutions from "@/components/content/home-solutions.vue";
import ClientFeedback from '@/components/content/client-feedback.vue';
import FaqAccordion from "@/components/content/faq-accordion.vue";
import GalleryVideo from "@/components/content/gallery-video.vue";
import FooterSeven from '@/components/common/Footers/FooterSeven.vue';
import sanity from "../../../sanity.js";
import SplashScreen from "@/components/content/splash-screen.vue";
const query = `*[_type == "home"]{
  _id,
  title,
  slug,
  hero{
    ...,
    title,
    subtitle,
    blockText,
    singleLink{
      slug,
      text
    },
    image{
      title,
      image{
        asset->{
          url,
          metadata{
            dimensions{
              height,
              width
            }
          }
        }
      }
    }
  },
  heroCarousel[]{
    _key,
    title,
    image{
      alt,
      image{
        asset->{
          url
        }
      }
    },
    icon{
      alt,
      image{
        asset->{
          url
        }
      }
    }
  },
  blockText,
  sectionBlocks[]{
    _id,
    title,
    blockText,
    singleLink,
    image{
      text,
      alt,
      image{
        asset->{
          url,
          metadata{
            dimensions{
              height,
              width
            }
          }
        }
      }
    }
  }
 }[0]`;
export default {
    name: "VR_LandingMain",
    components: {
      SplashScreen, StepsCarousel, HomeSolutions, HeaderTwo, HeroBanner, LogoCarousel, ClientFeedback, FaqAccordion, GalleryVideo, FooterSeven },
  data() {
    return {
      loading: true,
      content: [],
      showSplash: true,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.error = this.home = null;
      this.loading = true;
      sanity.fetch(query).then(
          (content) => {
            this.loading = false;
            this.content = content;
          },
          (error) => {
            this.error = error;
          }
      );
    },
  },
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.75s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
